// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1FPSd","inputWrap":"styles_inputWrap__mqokH","input":"styles_input__3gAtQ"};